import React from 'react';

/**
 * Queue Metrics Card Component
 * Displays individual queue metrics with trend indicators
 */
const QueueMetricsCard = ({ 
  title, 
  value, 
  change, 
  theme, 
  icon, 
  isError = false,
  subtitle = null 
}) => {
  const getChangeColor = () => {
    if (change === 0) return theme === 'dark' ? 'text-gray-400' : 'text-gray-500';
    
    // For error metrics, positive change is bad (red), negative is good (green)
    if (isError) {
      return change > 0 
        ? 'text-red-500' 
        : 'text-green-500';
    }
    
    // For normal metrics, positive change is good (green), negative is bad (red)
    return change > 0 
      ? 'text-green-500' 
      : 'text-red-500';
  };

  const getChangeIcon = () => {
    if (change === 0) return '→';
    
    // For error metrics, reverse the logic
    if (isError) {
      return change > 0 ? '↗' : '↘';
    }
    
    return change > 0 ? '↗' : '↘';
  };

  const formatChange = (change) => {
    if (change === 0) return '0%';
    const sign = change > 0 ? '+' : '';
    return `${sign}${change.toFixed(1)}%`;
  };

  return (
    <div className={`${
      theme === 'dark' 
        ? 'bg-gray-800 border-gray-700' 
        : 'bg-white border-gray-200'
    } rounded-lg shadow border p-6 transition-all hover:shadow-lg`}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="flex items-center">
            <span className="text-2xl mr-3">{icon}</span>
            <div>
              <p className={`text-sm font-medium ${
                theme === 'dark' ? 'text-gray-300' : 'text-gray-600'
              }`}>
                {title}
              </p>
              {subtitle && (
                <p className={`text-xs ${
                  theme === 'dark' ? 'text-gray-400' : 'text-gray-500'
                }`}>
                  {subtitle}
                </p>
              )}
            </div>
          </div>
          
          <div className="mt-3">
            <p className={`text-2xl font-bold ${
              theme === 'dark' ? 'text-white' : 'text-gray-900'
            }`}>
              {value}
            </p>
            
            {change !== undefined && (
              <div className="flex items-center mt-1">
                <span className={`text-sm font-medium ${getChangeColor()}`}>
                  {getChangeIcon()} {formatChange(change)}
                </span>
                <span className={`text-xs ml-2 ${
                  theme === 'dark' ? 'text-gray-400' : 'text-gray-500'
                }`}>
                  vs previous period
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QueueMetricsCard;
